export const ALLOWED_PATHS = [
  '/',
  '/admin',
  '/announcement-dashboard',
  '/announcement-detail',
  '/announcements',
  '/broadcast-email',
  '/create-account',
  '/email-enquiries',
  '/forgot-password',
  '/list-management',
  '/login',
  '/manage-admin',
  '/manage-content',
  '/manage-content/edit',
  '/manage-content/create',
  '/manage-investors',
  '/manage-prompts',
  '/manage-role',
  '/manage-subscriptions',
  '/manage-settings',
  '/manage-nominee',
  '/manage-super-admin',
  '/my-profile',
  '/my-questions',
  '/news-insights',
  '/notification-preferences',
  '/questions',
  '/research',
  '/security',
  '/setting',
  '/social-sharing',
  '/support',
  '/terms',
  '/theme-settings',
  '/settings',
  '/settings/admin-permissions',
  '/settings/admin-permissions/edit-admin',
  '/settings/company-theme',
  '/settings/website-widgets',
  '/settings/homepage-settings',
  '/settings/ai-workflows',
  '/settings/ai-workflows/edit',
  '/settings/ai-workflows/edit/draft-asx',
  '/settings/ai-workflows/edit/report',
  '/settings/list-management',
  '/company-reports',
  '/asx-drafts',
  '/create-content/content',
  '/create-content/draft-asx',
  '/create-content/draft-company-report',
  '/board-reports',
  '/board-reports/view-report',
  '/capital-events',
  '/capital-events/post-raise',
  '/capital-events/post-ipo'
]

// Display names for permission modules wherever they are shown in the UI.
// Backend permission names are stable identifiers (used as lookup keys in
// permission checks), so renames happen here, not in the database.
export const PERMISSION_LABELS: Record<string, string> = {
  'Company Reports': 'Draft Quarterly Reports',
  Placements: 'Post-Raise Analysis',
  'Post IPO': 'Post-IPO Analysis',
  'Manage Super Admin': 'Manage Super-Admin',
  'Manage Subscription': 'Manage Subscriptions',
  'Manage Settings': 'Manage settings'
}

export const permissionLabel = (name?: string | null) =>
  (name && PERMISSION_LABELS[name]) || name || ''
